import api from "../../../api/catalogs/failure_type.js";
const namespaced = true;

const state = {
    failure_type_data: [],
    loading_type_data: false,
    new_failure_type: null
};
const mutations = {
    SET_FAILURE_TYPE(state, data) {
        state.failure_type_data = data;
    },
    SET_LOADING_FAILURE(state, data) {
        state.loading_type_data = data;
    },
    SET_NEW_FAILURE_TYPE(state, data) {
        state.new_failure_type = data;
    },
    ADD_NEW_FAILURE_TYPE(state, data) {
        state.failure_type_data.unshift(data)
    },
    UPDATE_NEW_FAILURE_TYPE(state, data) {
        //state.operative_structure.find(item => item.id === value.plant_id).production_areas.find(item => item.id === value.id).name = value.name;
        state.failure_type_data.find(item => item.id === data.id ).name = data.name;
        state.failure_type_data.find(item => item.id === data.id ).plant_id = data.plant_id;
        state.failure_type_data.find(item => item.id === data.id ).plant = data.plant;
    },
    UPDATE_STATE_FAILURE_TYPE(state, data){
        state.failure_type_data.find(item => item.id === data.id).active = data.active;
    },
};
const actions = {
    getFailureType(context) {
        context.commit('SET_LOADING_FAILURE', true);
        return new Promise((resolve) => {
            api.getFailureType().then(function (res) {
                context.commit("SET_FAILURE_TYPE", res.data.data);
                context.commit("delay_event/SET_FILTER_FAILURE_TYPE", res.data.data, { root: true });
                context.commit('SET_LOADING_FAILURE', false);
                resolve(res.data);
            })
                .catch(function (error) {
                    context.commit('SET_LOADING_FAILURE', false);
                    console.log(error);
                });
        });
    },
    indexForDelayEvent(context) {
        context.commit('SET_LOADING_FAILURE', true);
        return new Promise((resolve) => {
            api.indexForDelayEvent().then(function (res) {
                context.commit("SET_FAILURE_TYPE", res.data.data);
                context.commit("delay_event/SET_FILTER_FAILURE_TYPE", res.data.data, { root: true });
                context.commit('SET_LOADING_FAILURE', false);
                resolve(res.data);
            })
                .catch(function (error) {
                    context.commit('SET_LOADING_FAILURE', false);
                    console.log(error);
                });
        });
    },
    storeFailureType(context, data) {
        context.commit('SET_LOADING_FAILURE', true);
        return new Promise((resolve) => {
            api.storeFailureType(data).then(function (res) {
                context.commit("ADD_NEW_FAILURE_TYPE", res.data.data);
                context.commit('SET_LOADING_FAILURE', false);
                context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: res.data.message, }, { root: true });
                resolve(res.data);
            }).catch(function (error) {
                context.commit('SET_LOADING_FAILURE', false);
                context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: error.messages, }, { root: true });
            });
        });
    },
    updateFailureType(context, data) {
        context.commit('SET_LOADING_FAILURE', true);
        return new Promise((resolve) => {
            api.updateFailureType(data).then(function (res) {
                context.commit("UPDATE_NEW_FAILURE_TYPE", res.data.data);
                context.commit('SET_LOADING_FAILURE', false);
                context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: res.data.message, }, { root: true });
                resolve(res.data);
            }).catch(function (error) {
                context.commit('SET_LOADING_FAILURE', false);
                context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: error.messages, }, { root: true });
            });
        });
    },
    changeActiveStatus(context, id) {
        context.commit('SET_LOADING_FAILURE', true);
        return new Promise((resolve) => {
            api.changeActiveStatus(id).then(function (res) {
                context.commit("UPDATE_STATE_FAILURE_TYPE", res.data.data);
                context.commit('SET_LOADING_FAILURE', false);
                context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: res.data.message, }, { root: true });
                resolve(res.data);
            }).catch(function (error) {
                context.commit('SET_LOADING_FAILURE', false);
                context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: error.messages, }, { root: true });
            });
        });
    },
};

const getters = {
    failureTypeGetter(state) {
        return state.failure_type_data;
    },
    getFailureNameType(state) {
        return state.failure_type_data.map(({ id, name }) => ({ id, name }));
    },
};

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
};
